import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { ReqMethods, ghl } from "enums";
import env from "config";
import { useAppServices } from "hook/services";

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");
  const associate = async (creds) => {
    var payload = {
      ghl: {
        location_id: creds.locationId,
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
      update_pushed:false
    };

    const { response } = await AppServices.brand.update({ payload });

    if (!response) {
      setTimeout(() => {
        window.close();
      }, 5000);
      return setError("Something went wrong while integration, please try latter");
    }
    setError("App installed successfully. You need to refresh the page to see the directory menu in the sidebar.");
    await AppServices.webhook.load_dummy_data({
        query:`locationId=${creds.locationId}`,
    })
    setTimeout(() => {
      window.close();
    }, 5000);
    return setError("dummy data loaded successfully");
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.LOCATION_CLIENT_ID,
        client_secret: env.GHL.LOCATION_CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) {
      // setTimeout(() => {
      //   window.close();
      // }, 2000);
      return setError("Something went wrong while integration, please try latter")};
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
    return response && associate(response.data);
  };
  let pageLoad = true;
  const onLoad = () => {
    if (pageLoad) {
      getCreds();
      pageLoad = false;
    }
  };

  useEffect(onLoad, []);

  return (
    <SoftBox>
      {!Error && <SoftBox>Integrating please wait...</SoftBox>}
      {Error && (
        <SoftBox>
          {Error}
          {/* <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton> */}
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default GHL;
